module.exports = __webpack_public_path__ + "5ab21ec6ddf55334d5a1e1a61e3015e4.svg";